import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Subscription, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';

import { AbstractPropertyEditorBase, DropDownPropertyEditorSetting } from '../../types/property-editor.types';
import { DynamicFormDesignerConfig } from '../../utils/dynamic-form-designer-config';
import { AbstractControl } from '../../types/control.types';

@Component({
  selector: 'df-drop-down-property-editor',
  templateUrl: './drop-down-property-editor.component.html',
  styleUrls: ['./drop-down-property-editor.component.css']
})
export class DropDownPropertyEditorComponent extends AbstractPropertyEditorBase implements OnInit, OnDestroy {
  @Input() set settings(settings: DropDownPropertyEditorSetting<any>) {
    this._settings = settings;
  }
  get settings() {
    return this._settings;
  }

  private _settings: DropDownPropertyEditorSetting<any>;
  private _parentValueChangedSubscription: Subscription;
  private _itemLoading = false;
  private _firstChange = true;

  constructor(
    private httpClient: HttpClient,
    private designerConfig: DynamicFormDesignerConfig,
    private commonConfig: DynamicFormCommonConfig
  ) {
    super();
  }

  ngOnInit() {
    if (this.settings.parentValueChanged) {
      this._parentValueChangedSubscription = this.settings.parentValueChanged.subscribe(
        (s: { target: AbstractControl<any>; value: any }) => {
          this.getItems(s).subscribe((_) => {
            // éç¬¬ä¸æ¬¡å¼ååï¼ç¼è¾ï¼ï¼æ¸ç©ºvalueå¼ã
            if (this._firstChange) {
              this._firstChange = false;
            } else {
              this.value = null;
            }
          });
        }
      );
    }

    const sub = this.getItems().subscribe((s) => {
      this.emitData();
      sub.unsubscribe();
    });
  }

  ngOnDestroy(): void {
    if (this._parentValueChangedSubscription) {
      this._parentValueChangedSubscription.unsubscribe();
    }
  }

  protected afterSetControlValue(value: any) {
    this.valueChange.emit(value);
    if (this._itemLoading) {
      return;
    }
    this.emitData();
  }

  afterControlValueInit() {
    // é»è®¤å¦ææå¼ ä¸å è¿å¥è¯ä¸é¢éé¡¹å è½½ä¸åºæ¥
    this.afterSetControlValue(this.value);
  }

  private emitData() {
    if (this.settings && this.settings.valueChanged) {
      const items = this.settings.items.filter((x: any) => x[this.settings.valueMember] === this.value);
      this.settings.valueChanged.emit({ target: this.control, value: items.length === 0 ? undefined : items[0] });
    }
    this.emitOriginData();
  }

  private emitOriginData() {
    if (this.settings.items && this.settings.emitOriginData) {
      const item = this.settings.items.find((x: any) => x[this.settings.valueMember] === this.value);
      if (item) {
        this.originValueChange.emit(item);
      }
    }
  }

  private getItems(parent?: { target: AbstractControl<any>; value: any }) {
    const subject = new Subject();

    if (this.settings.getItemsAsync) {
      this._itemLoading = true;
      this.settings
        .getItemsAsync(this.designerConfig, this.httpClient, parent)
        .pipe(
          finalize(() => {
            subject.complete();
            this._itemLoading = false;
          })
        )
        .subscribe(
          (s) => {
            this.settings.items = s;
            subject.next();
          },
          (error) => {
            this.commonConfig.log.error(`è·åæ°æ®å¤±è´¥`, error);
            subject.error('è·åæ°æ®å¤±è´¥');
          }
        );
    } else {
      subject.next();
      subject.complete();
    }
    return subject.asObservable();
  }
}
